// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationAdditionId } from './FermentationAddition';
import { fermentationTimepointId } from './FermentationTimepoint';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationAdditionWeightLogId = (z.number());
export const fermentationAdditionWeightLog = z.object({
    id: fermentationAdditionWeightLogId,
    addition_id: fermentationAdditionId,
    timepoint_id: fermentationTimepointId,
    container_weight_g: z.string().nullable(),
    created_at: z.date(),
    created_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const fermentationAdditionWeightLogInitializer = z.object({
    id: fermentationAdditionWeightLogId.optional(),
    addition_id: fermentationAdditionId,
    timepoint_id: fermentationTimepointId,
    container_weight_g: z.string().optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const fermentationAdditionWeightLogMutator = z.object({
    id: fermentationAdditionWeightLogId.optional(),
    addition_id: fermentationAdditionId.optional(),
    timepoint_id: fermentationTimepointId.optional(),
    container_weight_g: z.string().optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FermentationAdditionWeightLog.js.map